import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useState } from "react";

import { AddPromptModal } from "./AddPromptModal";

function AddPromptBtn() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        icon={<PlusOutlined />}
        size="small"
        onClick={() => setOpen(true)}
      >
        New Field
      </Button>
      <AddPromptModal open={open} setOpen={setOpen} />
    </>
  );
}

export { AddPromptBtn };
